export default {
  lang: 'zh_tw',
  api: false
}